import axios from "axios";
import moment from "moment";
import router from "../../router";

const base_url = process.env.VUE_APP_WEB_URL;
const root_url = process.env.VUE_APP_ROOT_URL;
const root_url_log = process.env.VUE_APP_ROOT_URL_LOG;
const axios_url = process.env.VUE_APP_AXIOS_URL;
const agora_token_url = process.env.VUE_APP_AGORA_TOKEN_URL;
const agora_record_url = process.env.VUE_APP_AGORA_RECORD_URL;
const local = "https://localhost";

const backend = axios.create({
  baseURL: axios_url,
});

const hitutoraxios = axios.create({
  baseURL: root_url,
});

const hitutoraxiosTest = axios.create({
  baseURL: axios_url ? axios_url.replace(/\/api$/, '') : `${base_url}:3000`,
});

//repo -> agoratokenservice
const agoraAxios = axios.create({
  baseURL: agora_token_url || `${base_url}:8099`,
});

//repo -> agorarecordbackend
const aograRecordAxios = axios.create({
  baseURL: agora_record_url || `${base_url}:8097`,
});

const im_service_url = process.env.VUE_APP_IM_SERVICE_URL;

const imcasalomaaxios = axios.create({
  baseURL: im_service_url || `${base_url}:3003/api`,
});

const imCasalomaAxios = axios.create({
  baseURL: im_service_url || `${base_url}:3008/api`,
});

const mainHitutorLog = axios.create({
  baseURL: root_url_log,
});

const hasProperty = (obj, propertyName) => {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop))
      if (prop == propertyName) {
        return true;
      }
  }

  return false;
};

const sendMainHitutorLog = async ({ state, commit }, payload) => {
  const response = await mainHitutorLog.post(`/Log/InsertRabbitMQ`, payload, {
    validateStatus: false,
  });
  console.log(response);
  try {
    if (response.data.ErrorCode != 0) {
      console.log("Failed to Send Log");
    } else {
      console.log("Successfully to Send Log");
    }
    console.log(response);
  } catch (error) {
    console.error(error);
  }
  // console.log("test");
};

const generateRecordingUid = (uid) => {
  let hash = 0;
  for (let i = 0; i < uid.length; i++) {
    hash = (hash << 5) - hash + uid.charCodeAt(i);
    hash |= 0; // force 32-bit
  }

  // Make it positive and trim to 8 digits
  const positiveHash = Math.abs(hash) % 100000; // max 8 digits

  return positiveHash + Math.floor(Math.random() * 100000); 
};



const getBrowserType = () => {
  const userAgent = navigator.userAgent;
  if (/MSIE|Trident/.test(userAgent)) {
    return "Internet Explorer";
  } else if (/Edge\/\d./i.test(userAgent)) {
    return "Microsoft Edge";
  } else if (
    /Chrome/.test(userAgent) &&
    !/Edge\/\d./i.test(userAgent) &&
    !/OPR/.test(userAgent)
  ) {
    return "Google Chrome";
  } else if (
    /Safari/.test(userAgent) &&
    !/Chrome/.test(userAgent) &&
    !/OPR/.test(userAgent)
  ) {
    return "Safari";
  } else if (/Firefox/.test(userAgent)) {
    return "Mozilla Firefox";
  } else if (/OPR/.test(userAgent)) {
    return "Opera";
  } else {
    return "Unknown";
  }
};

const getMobileBrowserType = () => {
  const userAgent = navigator.userAgent;
  if (/Android/.test(userAgent)) {
    if (/Firefox/.test(userAgent)) {
      return "Firefox Mobile (Android)";
    } else if (/Chrome/.test(userAgent)) {
      return "Google Chrome Mobile (Android)";
    } else if (/SamsungBrowser/.test(userAgent)) {
      return "Samsung Internet (Android)";
    } else {
      return "Android Browser";
    }
  } else if (/iPhone|iPad|iPod/.test(userAgent)) {
    if (/CriOS/.test(userAgent)) {
      return "Google Chrome Mobile (iOS)";
    } else if (/FxiOS/.test(userAgent)) {
      return "Firefox Mobile (iOS)";
    } else {
      return "Safari Mobile (iOS)";
    }
  } else if (/Windows Phone|IEMobile|WPDesktop/.test(userAgent)) {
    return "Internet Explorer Mobile";
  } else if (/Opera Mini/.test(userAgent)) {
    return "Opera Mini";
  } else if (/BB10|PlayBook|BlackBerry/.test(userAgent)) {
    return "BlackBerry Browser";
  } else {
    return "Unknown Mobile Browser";
  }
};

const isMobileBrowser = () => {
  return /Mobi|Android/i.test(navigator.userAgent);
};

const classActions = {
  async checkImCasalomaClass({ state, commit }, className) {
    try {
      const response = await imCasalomaAxios.get(
        `/class/checkclass/${className}`,
        {}
      );
      if (response.data.error) {
        console.log("Response IM Casaloma Check Class Error");
        console.log(response);
        commit(`setIMCasalomaClassAvailability`, false);
        commit(`setErrorLogs`, {
          name: "checkImCasalomaClass",
          error: response,
          problem: "Response IM Casaloma Check Class Error",
        });
      } else {
        commit(`setIMCasalomaClassAvailability`, true);
      }
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(response) });
    } catch (error) {
      console.log(error);
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "checkImCasalomaClass (catch)",
        error: error,
        problem: "Response IM Casaloma Check Class Error",
      });
    }
  },

  async checkImCasalomaUser({ state, commit }, email) {
    try {
      const response = await imCasalomaAxios.get(`/user/` + email);
      if (response.data.error) {
        console.log("Response CheckIM Casaloma User Error");
        console.log(response);
        commit(`setIMCasalomaUserAvailability`, false);
        commit(`setErrorLogs`, {
          name: "checkImCasalomaUser",
          error: response,
          problem: "Response IM Casaloma Check User Error",
        });
      } else {
        commit(`setIMCasalomaUserAvailability`, true);
      }
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(response) });
    } catch (error) {
      console.log(error);
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "checkImCasalomaUser (catch)",
        error: error,
        problem: "Response IM Casaloma Check User Error",
      });
    }
  },

  async createIMLogin({ state, commit }, payload) {
    try {
      const response = await imCasalomaAxios.post(`/user/login`, payload);
      if (response.data.error) {
        console.log("Response User Login Error");
        console.log(response);
        commit(`setIMCasalomaUserLogin`, response.payload);
        commit(`setErrorLogs`, {
          name: "checkImLogin",
          error: response,
          problem: "Response User Login Error",
        });
      } else {
        commit(`setIMCasalomaUserLogin`, response.payload);
      }
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(response) });
    } catch (error) {
      console.log(error);
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "checkImLogin (catch)",
        error: error,
        problem: "Response IM Login Error",
      });
    }
  },

  async createClass({ state, commit }, payload) {
    try {
      const response = await imCasalomaAxios.post(`/class`, payload);
      if (response.data.error) {
        console.log("Response Class Error");
        console.log(response);
        commit(`setIMCasalomaUserClass`, response.payload);
        commit(`setErrorLogs`, {
          name: "createClassIM",
          error: response,
          problem: "Response IM Casaloma User Class Error",
        });
      } else {
        commit(`setIMCasalomaUserClass`, response.payload);
      }
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(response) });
    } catch (error) {
      console.log(error);
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "createClassIM (catch)",
        error: error,
        problem: "Response IM Casaloma Create Class Error",
      });
    }
  },

  async createIMRegister({ state, commit }, payload) {
    try {
      let formData = new FormData();
      formData.append("name", payload.name);
      formData.append("email", payload.email);
      formData.append("password", payload.password);
      formData.append("contact", payload.contact);
      formData.append("image", payload.image);
      formData.append("userType", payload.userType);

      const responseRegister = await imCasalomaAxios.post("/user", payload);
      // const responseRegister=await imCasalomaAxios({
      //     method: 'post',
      //     url: '/user',
      //     data: formData,
      //     headers: {
      //         'Content-Type': `multipart/form-data`,
      //     },
      // });
      if (responseRegister.data.error) {
        console.log("Response Register Error");
        console.log(responseRegister);
        commit(`setErrorLogs`, {
          name: "createIMRegister",
          error: responseRegister,
          problem: "createIM Register Error",
        });
      } else {
        commit(`setIMCasalomaUserRegister`, payload);
      }
      sendMainHitutorLog(
        { state, commit },
        { Log: JSON.stringify(responseRegister) }
      );
    } catch (error) {
      console.log(error);
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "createIMRegister (catch)",
        error: error,
        problem: "Response IM Register Error",
      });
    }
  },

  async getIMRoomByName({ state, commit }, roomNameParam) {
    // console.log(state.currentUserCasalomaAccessToken)
    // const response=await imcasalomaaxios.get(`/rooms/find-by-roomname?roomname=`+roomNameParam,{ headers: {"authorization" : `Bearer ${state.currentUserCasalomaAccessToken}`} , validateStatus:false})
    const response = await imcasalomaaxios.get(
      `/rooms/find-by-roomname?roomname=` + roomNameParam,
      { validateStatus: false }
    );
    console.log(response);
    try {
      if (response.status == 200 && response.data == "") {
        console.log("Room is not found");
        commit(`setcheckCasalomaRoomNameAvailability`, false);
        commit(`setcasalomaRoomName`, roomNameParam);
        commit(`setErrorLogs`, {
          name: "getIMRoomByName",
          error: response,
          problem: "getIMRoomByName error",
        });
      } else {
        console.log("Room is found");
        commit(`setcheckCasalomaRoomNameAvailability`, true);
        commit(`setcasalomaRoomName`, roomNameParam);
      }
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(response) });
    } catch (error) {
      console.log(error);
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "getIMRoomByName (catch)",
        error: error,
        problem: "Response getIMRoomByName Error",
      });
    }
  },

  async createIMCasaloma({ state, commit }, payload) {
    const response = await imcasalomaaxios.post(`/users`, payload, {
      validateStatus: false,
    });
    try {
      if (response.status != 201) {
        commit(`setcurrentUserCasalomaRegistered`, false);
        commit(`setErrorLogs`, {
          name: "createIMCasaloma",
          error: response,
          problem: "createIMCasaloma error",
        });
      } else {
        commit(`setcurrentUserCasalomaRegistered`, true);
      }
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(response) });
    } catch (error) {
      console.error(error);
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "createIMCasaloma(catch)",
        error: error,
        problem: "Response createIMCasaloma Error",
      });
    }
  },

  async loginIMCasaloma({ state, commit }, payload) {
    const response = await imcasalomaaxios.post(`/users/login`, payload, {
      validateStatus: false,
    });
    console.log(response);
    try {
      if (response.status != 201) {
        console.log("User Not Found");
        commit(`setcurrentUserCasalomaRegistered`, false);
        commit(`setErrorLogs`, {
          name: "loginIMCasaloma",
          error: response,
          problem: "problem when login IMCasaloma",
        });
      } else {
        console.log("User Found");
        commit(`setcurrentUserCasalomaRegistered`, true);
        commit(`setcurrentResponseIMCasaloma`, response.data);
        commit(`setcurrentUserCasalomaAccessToken`, response.data.access_token);
      }
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(response) });
    } catch (error) {
      console.error(error);
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "loginIMCasaloma (catch)",
        error: error,
        problem: "loginIMCasaloma Error",
      });
    }
  },

  async getMaterialMediaByMediaFileUrl({ state, commit }, fileUrlParam) {
    commit("setDynamicCounterMediaFileUrl", false);
    const response = await this.$axios.get(
      `/materialmodel/detailsbyFileUrl` + fileUrlParam
    );
    if (response.data.error == false) {
      try {
        commit(
          `setDataGetMaterialByFileUrl`,
          response.data.payload.materialObject
        );
        sendMainHitutorLog(
          { state, commit },
          { Log: JSON.stringify(response.data) }
        );
      } catch (error) {
        commit(`setDynamicCounterMediaFileUrl`, false);
        sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
        commit(`setErrorLogs`, {
          name: "getMaterialByMediaFileUrl (error)",
          error: error,
          problem: "problem when call getMaterialMediaByMediaFileUrl",
        });
      }
    }
  },

  async getMaterialMediaByClassID({ state, commit }, payload) {
    const response = await this.$axios.get(
      `/materialmodel/details`,
      payload,
      {}
    );
    if (response.data.error == false) {
      try {
        sendMainHitutorLog(
          { state, commit },
          { Log: JSON.stringify(response.data) }
        );
      } catch (error) {
        console.log(error);
        sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
        commit(`setErrorLogs`, {
          name: "getMaterialMediaByClassID (catch)",
          error: error,
          problem: "Problem when call getMaterialMediaByClassID",
        });
      }
    } else {
      commit(`setErrorLogs`, {
        name: "getMaterialMediaByClassID",
        error: response,
        problem: "Problem when call getMaterialMediaByClassID",
      });
    }
  },

  async getMaterialMediaByEnglishName({ state, commit }, payload) {
    const response = await this.$axios.get(
      `/materialmodel/detailsbyEnglishName`,
      payload,
      {}
    );
    if (response.data.error == false) {
      try {
        sendMainHitutorLog(
          { state, commit },
          { Log: JSON.stringify(response.data) }
        );
      } catch (error) {
        console.log(error);
        sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
        commit(`setErrorLogs`, {
          name: "getMaterialMediaByEnglishName (catch)",
          error: error,
          problem: "Problem when call getMaterialMediaByEnglishName",
        });
      }
    } else {
      commit(`setErrorLogs`, {
        name: "getMaterialMediaByEnglishName",
        error: response,
        problem: "Problem when call getMaterialMediaByEnglishName",
      });
    }
  },

  async sendMaterialMedia({ state, commit }, payload) {
    const englishNameParam = payload["englishName"];
    const responseGetByFileUrl = await this.$axios.get(
      `/materialmodel/detailsbyEnglishName/` + englishNameParam
    );
    if (
      responseGetByFileUrl.data.payload.materialObject == null ||
      responseGetByFileUrl.data.payload.materialObject == undefined
    ) {
      const response = await this.$axios.post(`/materialmodel`, payload, {});
      if (response.data.error == false) {
        try {
          sendMainHitutorLog(
            { state, commit },
            { Log: JSON.stringify(response.data) }
          );
        } catch (error) {
          console.log(error);
          sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
          commit(`setErrorLogs`, {
            name: "sendMaterialMedia (catch)",
            error: error,
            problem: "Problem when call sendMaterialMedia",
          });
        }
      } else {
        commit(`setErrorLogs`, {
          name: "sendMaterialMedia",
          error: response,
          problem: "Problem when call sendMaterialMedia",
        });
      }
    } else {
      const response = await this.$axios.put(`/materialmodel`, payload, {});
      if (response.data.error == false) {
        try {
          sendMainHitutorLog(
            { state, commit },
            { Log: JSON.stringify(response.data) }
          );
        } catch (error) {
          console.log(error);
          sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
          commit(`setErrorLogs`, {
            name: "sendMaterialMedia (catch)",
            error: error,
            problem: "Problem when call sendMaterialMedia",
          });
        }
      } else {
        commit(`setErrorLogs`, {
          name: "sendMaterialMedia",
          error: response,
          problem: "Problem when call sendMaterialMedia",
        });
      }
    }
  },

  async sendChat({ state, commit }, payload) {
    const response = await hitutoraxios.post(
      `/api/NewTeachingPlatform/SendClassroomLiveChat`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${state.HiTutorToken}`,
        },
      }
    );
    if (!response.data.error) {
    }
  },

  async sendMediaChat({ state, commit }, payload) {
    const response = await hitutoraxios.post(
      `/api/NewTeachingPlatform/SendClassroomLiveChat`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${state.HiTutorToken}`,
        },
      }
    );
    if (!response.data.error) {
    }
  },

  async uploadTeacherMedia({ state, commit }, payload) {
    // console.log("payload",payload)
    try {
      const response = await hitutoraxiosTest.post(
        `/api/materialmodel/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${state.HiTutorToken}`,
          },
        }
      );

      if (response.data.IsSuccess) {
        sendMainHitutorLog(
          { state, commit },
          { Log: JSON.stringify(response.data) }
        );
      } else {
        commit(`setErrorLogs`, {
          name: "uploadMaterialMedia",
          error: response,
          problem: "Problem when call uploadMaterialMedia",
        });
      }
    } catch (error) {
      console.log(error);
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "uploadMaterialMedia",
        error: error,
        problem: "Problem when call uploadTeacherMedia",
      });
    }
  },

  async uploadMaterialRecord({ state, commit }, payload) {
    const response = await hitutoraxios.post(
      `/api/NewTeachingPlatform/UploadMaterialRecord`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${state.HiTutorToken}`,
        },
      }
    );
    try {
      if (response.data.IsSuccess) {
        sendMainHitutorLog(
          { state, commit },
          { Log: JSON.stringify(response.data) }
        );
      } else {
        commit(`setErrorLogs`, {
          name: "uploadMaterialRecord",
          error: response,
          problem: "Problem when call uploadMaterialRecord",
        });
      }
    } catch (error) {
      console.log(error);
      SS;
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "uploadMaterialRecord",
        error: error,
        problem: "Problem when call uploadTeacherRecord",
      });
    }
  },

  async getClassroomMaterials({ state, commit }, payload) {
    const response = await hitutoraxios.post(
      `/api/NewTeachingPlatform/GetClassroomMaterials`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${state.HiTutorToken}`,
        },
      }
    );
    try {
      if (response.data.IsSuccess) {
        sendMainHitutorLog(
          { state, commit },
          { Log: JSON.stringify(response.data) }
        );
        commit("setClassroomMaterial", response.data);
      }
    } catch (error) {
      console.log(error);
      SS;
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "getClassroomMaterials",
        error: error,
        problem: "Problem when call getClassroomMaterials",
      });
    }
  },

  async uploadJsonTeacherMedia({ state, commit }, payload) {
    const response = await hitutoraxiosTest
      .post(`/api/materialmodel/json/`, payload, {
        headers: {
          Authorization: `Bearer ${state.HiTutorToken}`,
        },
      })
      .then((response) => {
        console.log(response.data); // handle the response data
        sendMainHitutorLog(
          { state, commit },
          { Log: JSON.stringify(response.data) }
        );
      })
      .catch((error) => {
        console.error("error", error);
        sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
        commit(`setErrorLogs`, {
          name: "uploadMaterialMedia",
          error: error,
          problem: "Problem when call uploadMaterialMedia",
        });
        return Promise.reject(error);
      });
  },

  async uploadTeacherComment({ state, commit }, payload) {
    const response = await hitutoraxios.post(
      `/api/NewTeachingPlatform/UploadTeacherComments`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${state.HiTutorToken}`,
        },
      }
    );
    try {
      if (response.data.IsSuccess) {
        alert("Teacher's comment is successfully uploaded");

        sendMainHitutorLog(
          { state, commit },
          { Log: JSON.stringify(response.data) }
        );
      } else {
        commit(`setErrorLogs`, {
          name: "uploadTeacherComment",
          error: response,
          problem: "Problem when call uploadTeacherComment",
        });
      }
    } catch (error) {
      console.log(error);
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "uploadTeacherComment",
        error: error,
        problem: "Problem when call uploadTeacherComment",
      });
    }
  },

  async callCustomer({ state, commit }, payload) {
    const response = await hitutoraxios.post(
      `/api/NewTeachingPlatform/CallCustomerService`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${state.HiTutorToken}`,
        },
      }
    );
    try {
      if (response.data.IsSuccess) {
        alert("Customer service is successfully called");

        sendMainHitutorLog(
          { state, commit },
          { Log: JSON.stringify(response.data) }
        );
      } else {
        commit(`setErrorLogs`, {
          name: "callCustomer",
          error: response,
          problem: "Problem when call callCustomer",
        });
      }
    } catch (error) {
      console.log(error);
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "callCustomer (catch)",
        error: error,
        problem: "Problem when call callCustomer",
      });
    }
  },

  async checkInClassroom({ state, commit, dispatch }, payload) {
    const response = await hitutoraxios.post(
      `/api/NewTeachingPlatform/CheckInClassroom`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${state.HiTutorToken}`,
        },
      }
    );
    try {
      // console.log(response);
      commit("setCheckInState", response);
      // if(response.data.IsSuccess){
      // alert("Class is starting");
      // }

      sendMainHitutorLog(
        { state, commit },
        { Log: JSON.stringify(response.data) }
      );
      commit(`setErrorLogs`, {
        name: "checkInClassroom",
        error: response,
        problem: "Problem when call checkInClassroom",
      });
    } catch (error) {
      console.log(error);
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "checkInClassroom (catch)",
        error: error,
        problem: "Problem when call checkInClassroom",
      });
    }
  },

  async checkOutClassroom({ state, commit, dispatch }, payload) {
    const response = await hitutoraxios.post(
      `/api/NewTeachingPlatform/CheckOutClassroom`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${state.HiTutorToken}`,
        },
      }
    );
    try {
      commit("setCheckOutState", response);
      // console.log(response);
      // if(response.data.IsSuccess){
      // alert("Class is ended");
      // }

      sendMainHitutorLog(
        { state, commit },
        { Log: JSON.stringify(response.data) }
      );
      commit(`setErrorLogs`, {
        name: "checkOutClassroom",
        error: response,
        problem: "Problem when call checkOutClassroom",
      });
    } catch (error) {
      console.log(error);
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "checkOutClassroom (catch)",
        error: error,
        problem: "Problem when call checkOutClassroom",
      });
    }
  },

  async retrieveChats({ state, commit, dispatch }, payload) {
    const response = await hitutoraxios.post(
      `/api/NewTeachingPlatform/GetClassroomLiveChat`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${state.HiTutorToken}`,
        },
      }
    );
    try {
      console.log("retrieveChatsClass", response);
      if (!response.data.IsSuccess) {
        commit("setLiveChats", response.data.liveChatContents);

        sendMainHitutorLog(
          { state, commit },
          { Log: JSON.stringify(response.data) }
        );
        commit(`setErrorLogs`, {
          name: "retrieveChats",
          error: response,
          problem: "Problem when call retrieveChats",
        });
      } else {
        commit("setLiveChats", response.data.liveChatContents);
      }
    } catch (error) {
      console.log(error);
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "retrieveChats (catch)",
        error: error,
        problem: "Problem when call retrieveChats",
      });
    }
  },

  async disconnectRTC({ state, commit }, payload) {
    console.log(payload);
    try {
      const response = await hitutoraxios.post(
        `/api/NewTeachingPlatform/DisconnectedRtcServer`,
        {
          Identifier: payload.UserId,
          ClassroomId: state.classRoomId,
        },
        {
          headers: {
            Authorization: `Bearer ${state.HiTutorToken}`,
          },
        }
      );

      if (!response.data.IsSuccess) {
        commit(`setErrorLogs`, {
          name: "disconnectRTC",
          error: response,
          problem: "Problem when call disconnectRTC",
        });
      } else {
        commit(`setClearErrorLogs`, {
          name: "disconnectRTC",
          error: response,
          problem: "Problem when call disconnectRTC",
        });
      }

      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(response) });
      router.push("/");
    } catch (error) {
      console.log(error);
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "disconnectRTC (catch)",
        error: error,
        problem: "Problem when call disconnectRTC",
      });
    }
  },

  async disconnectRTC2({ state, commit }, payload) {
    console.log(payload);
    try {
      const response = await hitutoraxios.post(
        `/api/NewTeachingPlatform/DisconnectedRtcServer`,
        {
          Identifier: payload.UserId,
          ClassroomId: state.classRoomId,
        },
        {
          headers: {
            Authorization: `Bearer ${state.HiTutorToken}`,
          },
        }
      );

      if (!response.data.IsSuccess) {
        commit(`setErrorLogs`, {
          name: "disconnectRTC2",
          error: response,
          problem: "Problem when call disconnectRTC2",
        });
      } else {
        commit(`setClearErrorLogs`, {
          name: "disconnectRTC",
          error: response,
          problem: "Problem when call disconnectRTC",
        });
      }

      sendMainHitutorLog(
        { state, commit },
        { Log: JSON.stringify(response.data) }
      );
      router.push("/NewTeachingPlatform/index2");
    } catch (error) {
      console.log(error);
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "disconnectRTC2 (catch)",
        error: error,
        problem: "Problem when call disconnectRTC2",
      });
    }
  },

  async joinNewClassHitutorv2({ state, commit, dispatch }, payload) {
    commit("setClearErrorLogs");
    const response = await hitutoraxios.post(
      `/api/NewTeachingPlatform/GetEnterClassroomInfo`,
      payload,
      {}
    );
    try {
      if (response.data.IsSuccess) {
        //const isAnyClassMatesProps = Object.hasOwn(response.data, "classmateItems");
        const isAnyClassMatesProps = hasProperty(
          response.data,
          "classmateItems"
        );
        if (isAnyClassMatesProps == false || isAnyClassMatesProps === false) {
          commit("setOnlineUsers", []);
        } else {
          commit("setOnlineUsers", response.data.classmateItems);
        }

        // 2022-12-15 Peter 進教室整理訊息array
        if (response.data.liveChatContents.length > 0) {
          for (var i = 0; i < response.data.liveChatContents.length; i++) {
            var ContentArray = JSON.parse(
              response.data.liveChatContents[i].Content
            );

            response.data.liveChatContents[i].SendTime = moment(
              response.data.liveChatContents[i].SendTime
            ).format("YYYY-MM-DD HH:mm:ss");
            response.data.liveChatContents[i].FileName = ContentArray.FileName;
            response.data.liveChatContents[i].FileUrl = ContentArray.FileUrl;
            response.data.liveChatContents[i].Message = ContentArray.Message;
          }

          commit("setClassroomMessage", response.data.liveChatContents);
        } else {
          commit("setClassroomMessage", []);
        }

        commit(
          "setLiveChatChannel",
          response.data.LiveChatChannel.split("G-")[1]
        );

        // commit('setClassRoomId',2216502);
        commit("setClassRoomId", response.data.ClassroomId);
        commit("setHiTutorToken", response.data.Token);
        commit("setUserId", response.data.UserId);
        console.log("dataClass", response);
        if (response.data.userType == 1) {
          commit("setTeacherName", response.data.UserName);
        }
        commit("setClassTime", response.data.ClassTime);
        // commit('setBeginTimeStamp',1665459025);
        commit("setBeginTimeStamp", response.data.BeginTimeStamp);
        commit("setEndTimeStamp", response.data.EndTimeStamp);

        commit("setLessonRecordUrlStore", response.data.LessonRecordUrl);
        commit("setTBUrlStore", response.data.TBUrl);

        try {
          /* Storing user's device details in a variable*/
          let details = navigator.userAgent;

          /* Creating a regular expression 
                    containing some mobile devices keywords 
                    to search it in details string*/
          let regexp = /android|iphone|kindle|ipad/i;

          /* Using test() method to search regexp in details
                    it returns boolean value*/
          let isMobileDevice = regexp.test(details);
          let device;
          let OSName;
          let ip_address;

          if (isMobileDevice) {
            device = "Mobile";
          } else {
            device = "Desktop";
          }

          if (navigator.appVersion.indexOf("Win") != -1) OSName = "Windows OS";
          if (navigator.appVersion.indexOf("Mac") != -1) OSName = "MacOS";
          if (navigator.appVersion.indexOf("X11") != -1) OSName = "UNIX OS";
          if (navigator.appVersion.indexOf("Linux") != -1) OSName = "Linux OS";

          const url = "https://api.ipify.org/?format=json";

          ip_address = await fetch(url)
            .then((response) => response.json())
            .then((data) => data);

          var hituteIdentifier = response.data.UserId + "hitute-" + Date.now();
          commit("setHituteIdentifier", hituteIdentifier);

          let datapacket = {};
          // alert(JSON.stringify(datapacket));
          var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
          var version_number = raw ? parseInt(raw[2], 10) : false;

          if (isMobileBrowser()) {
            datapacket = {
              Identifier: hituteIdentifier,
              ClassroomId: response.data.ClassroomId,
              OS: OSName,
              Model: device,
              Browser: getMobileBrowserType(),
              BrowserVersion: window.navigator.appVersion,
              ClientIP: String(ip_address.ip),
              Headers: window.navigator.userAgent,
            };

            if (
              window.navigator.vendor === "Google Inc." ||
              getMobileBrowserType() === "Google Chrome Mobile (Android)" ||
              getMobileBrowserType() === "Google Chrome Mobile (iOS)"
            ) {
              if (version_number < 97) {
                commit(`setErrorLogs`, {
                  name: "browser version error",
                  error: "chrome version is not good",
                  problem:
                    "Brower Warning msg: 為了確保課程進行順暢，瀏覽器請使用 Chrome（版本：97......以上）。謝謝",
                });
                // alert("Brower Warning msg: 為了確保課程進行順暢，瀏覽器請使用 Chrome（版本：97......以上）。謝謝。")
              }
            } else {
              commit(`setErrorLogs`, {
                name: "not use chrome",
                error: "you are not using chrome",
                problem: "請使用Chrome瀏覽器以獲得最佳上課體驗",
              });
            }
          } else {
            datapacket = {
              Identifier: hituteIdentifier,
              ClassroomId: response.data.ClassroomId,
              OS: OSName,
              Model: device,
              Browser: getBrowserType(),
              BrowserVersion: window.navigator.appVersion,
              ClientIP: String(ip_address.ip),
              Headers: window.navigator.userAgent,
            };
            if (
              window.navigator.vendor === "Google Inc." ||
              getBrowserType() === "Google Chrome"
            ) {
              if (version_number < 97) {
                commit(`setErrorLogs`, {
                  name: "browser version error",
                  error: "chrome version is not good",
                  problem:
                    "Brower Warning msg: 為了確保課程進行順暢，瀏覽器請使用 Chrome（版本：97......以上）。謝謝",
                });
                // alert("Brower Warning msg: 為了確保課程進行順暢，瀏覽器請使用 Chrome（版本：97......以上）。謝謝。")
              }
            } else {
              commit(`setErrorLogs`, {
                name: "not use chrome",
                error: "you are not using chrome",
                problem: "請使用Chrome瀏覽器以獲得最佳上課體驗",
              });
            }
          }

          // alert(getMobileBrowserType());
          // alert(getBrowserType());
          const response_rtc_connected = await hitutoraxios.post(
            `/api/NewTeachingPlatform/ConnectedRtcServer`,
            datapacket,
            {
              headers: {
                Authorization: `Bearer ${response.data.Token}`,
              },
            }
          );

          // if (isMobileBrowser()) {

          // }
          // else {

          // }
          // var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
          // var version_number = raw ? parseInt(raw[2], 10) : false;
          // if(window.navigator.vendor == "Google Inc." || window.navigator.vendor === "Google Inc."){
          //     if(version_number<97){
          //         commit(`setErrorLogs`,{'name':'browser version error','error':'chrome version is not good','problem':'Brower Warning msg: 為了確保課程進行順暢，瀏覽器請使用 Chrome（版本：97......以上）。謝謝'});
          //         // alert("Brower Warning msg: 為了確保課程進行順暢，瀏覽器請使用 Chrome（版本：97......以上）。謝謝。")
          //     }
          // }else{
          //     commit(`setErrorLogs`,{'name':'not use chrome','error':'you are not using chrome','problem':'請使用Chrome瀏覽器以獲得最佳上課體驗'});

          // }

          // alert()

          // const response_media_object=await hitutoraxios.post(`/api/NewTeachingPlatform/GetClassroomMaterials`,{
          //   "ClassroomId": response.data.ClassroomId,
          //   "LastPage": 0,
          //   "RequestPages": 10,
          //   // "ClassroomId":2216502
          // },
          const response_media_object = await hitutoraxios.post(
            `/api/NewTeachingPlatform/GetClassroomMaterials`,
            {
              ClassroomId: response.data.ClassroomId,
              RequestPages: 10,
              // "ClassroomId":2216502
            },
            {
              headers: {
                Authorization: `Bearer ${response.data.Token}`,
              },
            }
          );

          console.log("Response Media Object");
          console.log(response_media_object);
          // Old handling materials data

          try {
            //const isAnyMessageProps = Object.hasOwn(response_media_object.data, "Message");
            const isAnyMessageProps = hasProperty(
              response_media_object.data,
              "Message"
            );
            if (isAnyMessageProps == false || isAnyMessageProps === false) {
              commit(
                "setMaterialMediaObject",
                response_media_object.data.MaterialMediaObject
              );
              commit(
                "setMaterialVedioObject",
                response_media_object.data.MaterialVedioObject
              );
              commit(
                "setMaterialObject",
                response_media_object.data.MaterialObject
              );
            } else {
              const responseMaterialObject = [];
              commit("setMaterialObject", responseMaterialObject);

              const responseVedioObject = [];
              commit("setMaterialVedioObject", responseVedioObject);

              const responseMaterialMediaObject = [];
              commit("setMaterialMediaObject", responseMaterialMediaObject);
            }
          } catch (error) {
            const responseMaterialObject = [];
            commit("setMaterialObject", responseMaterialObject);

            const responseVedioObject = [];
            commit("setMaterialVedioObject", responseVedioObject);

            const responseMaterialMediaObject = [];
            commit("setMaterialMediaObject", responseMaterialMediaObject);
            sendMainHitutorLog(
              { state, commit },
              { Log: JSON.stringify(error) }
            );
            commit(`setErrorLogs`, {
              name: "responseMaterialMediaObject (catch)",
              error: error,
              problem:
                "Problem when set responseMaterialMediaObject in Join Classroom 2",
            });
          }

          const currentUserName = response.data.UserName;
          const currentUserEmail = currentUserName + "@hitutor.com";

          const responseCheckCasalomaUser = await imCasalomaAxios.get(
            `/user/` + currentUserEmail
          );
          console.log(responseCheckCasalomaUser);
          if (responseCheckCasalomaUser.data.error == true) {
            commit(`setIMCasalomaUserAvailability`, false);
            const userDataForRegister = {
              name: currentUserName,
              email: currentUserEmail,
              password: "hitutor",
              contact: "000000",
              image: "null",
              userType: "TEACHER",
            };
            let formData = new FormData();
            formData.append("name", userDataForRegister.name);
            formData.append("email", userDataForRegister.email);
            formData.append("password", userDataForRegister.password);
            formData.append("contact", userDataForRegister.contact);
            formData.append("image", userDataForRegister.image);
            formData.append("userType", userDataForRegister.userType);

            commit(`setErrorLogs`, {
              name: "responseCheckCasalomaUser",
              error: error,
              problem:
                "Problem when set responseCheckCasalomaUser in Join Classroom 2",
            });

            const responseIMRegister = await imCasalomaAxios.post(
              `/user/`,
              formData
            );
            if (responseIMRegister.data.error == true) {
              commit(
                `setIMCasalomaUserRegister`,
                responseIMRegister.data.payload
              );
              commit(`setErrorLogs`, {
                name: "responseIMRegister",
                error: error,
                problem:
                  "Problem when set responseIMRegister in Join Classroom 2",
              });
            } else {
              commit(
                `setIMCasalomaUserRegister`,
                responseIMRegister.data.payload
              );

              commit(`setIMCasalomaUserAvailability`, true);
              const userDataForLogin = {
                email: currentUserEmail,
                password: "hitutor",
              };
              const responseIMLogin = await imCasalomaAxios.post(
                `/user/login`,
                userDataForLogin
              );
              console.log("Response IM Login");
              console.log(responseIMLogin);
              console.log(responseIMLogin.data);
              if (responseIMLogin.data.error == true) {
                commit(`setIMCasalomaUserLogin`, responseIMLogin.data.payload);
                commit(`setErrorLogs`, {
                  name: "responseIMLogin",
                  error: error,
                  problem:
                    "Problem when set responseIMLogin in Join Classroom 2",
                });
              } else {
                commit(`setIMCasalomaUserLogin`, responseIMLogin.data.payload);
                const { user, jwtToken } = responseIMLogin.data.payload;
                commit("setUser", { user, jwtToken });

                //if  class available
                const responseIMClass = await imCasalomaAxios.get(
                  `/class/checkclass/` + response.data.ClassroomId
                );
                console.log(responseIMClass);
                if (responseIMClass.data.payload.class == null) {
                  //create new class
                  const newClass = {
                    name: response.data.ClassroomId.toString(),
                    description:
                      "description " + response.data.ClassroomId.toString(),
                    createdBy: state.IMCasalomaUserLogin.user._id,
                    shortInfo:
                      "short info " + response.data.ClassroomId.toString(),
                    startTime: "2022-05-03T03:33:04.106+00:00",
                    endTime: "2025-06-03T03:33:04.106+00:00",
                  };

                  console.log(newClass);
                  let formDataClass = new FormData();
                  formDataClass.append("name", newClass.name);
                  formDataClass.append("shortInfo", newClass.shortInfo);
                  formDataClass.append("createdBy", newClass.createdBy);
                  formDataClass.append("description", newClass.description);
                  formDataClass.append("startTime", newClass.startTime);
                  formDataClass.append("endTime", newClass.endTime);
                  const responseIMCreateClass = await imCasalomaAxios.post(
                    `/class`,
                    newClass
                  );
                  console.log(responseIMCreateClass);
                  if (responseIMCreateClass.data.error == true) {
                    commit(`setErrorLogs`, {
                      name: "responseIMCreateClass",
                      error: responseIMCreateClass,
                      problem:
                        "Problem when set responseIMCreateClass in Join Classroom 2",
                    });
                  } else {
                    commit(
                      `setIMCasalomaUserClass`,
                      responseIMCreateClass.data.payload
                    );
                    const responseIMFetchChat = await imCasalomaAxios.get(
                      `/chat/${responseIMCreateClass.data.payload.class._id}`,
                      {}
                    );
                    console.log(responseIMFetchChat);
                    commit(`setIMCasalomaFetchChats`, responseIMFetchChat);
                    commit(
                      "setCurrentlyViewingClass",
                      responseIMCreateClass.data.payload.class
                    );
                  }
                } else {
                  //join class
                  commit(
                    `setIMCasalomaUserClass`,
                    responseIMClass.data.payload
                  );
                  const responseIMFetchChat = await imCasalomaAxios.get(
                    `/chat/${responseIMClass.data.payload.class._id}`,
                    {}
                  );
                  console.log(responseIMFetchChat);
                  commit(`setIMCasalomaFetchChats`, responseIMFetchChat);
                  commit(
                    "setCurrentlyViewingClass",
                    responseIMClass.data.payload.class
                  );
                }
              }
            }
          } else {
            commit(`setIMCasalomaUserAvailability`, true);
            const userDataForLogin = {
              email: currentUserEmail,
              password: "hitutor",
            };
            const responseIMLogin = await imCasalomaAxios.post(
              `/user/login`,
              userDataForLogin
            );
            console.log("Response IM Login");
            console.log(responseIMLogin);
            console.log(responseIMLogin.data);
            if (responseIMLogin.data.error == true) {
              commit(`setIMCasalomaUserLogin`, responseIMLogin.data.payload);
              commit(`setErrorLogs`, {
                name: "responseIMLogin",
                error: responseIMLogin,
                problem: "Problem when set responseIMLogin in Join Classroom 2",
              });
            } else {
              console.log("Success Login Response");
              commit(`setIMCasalomaUserLogin`, responseIMLogin.data.payload);
              const { user, jwtToken } = responseIMLogin.data.payload;
              commit("setUser", { user, jwtToken });
              //if class available
              const responseIMClass = await imCasalomaAxios.get(
                `/class/checkclass/` + response.data.ClassroomId
              );
              console.log(responseIMClass);
              if (responseIMClass.data.payload.class == null) {
                //create new class
                const newClass = {
                  name: response.data.ClassroomId.toString(),
                  description:
                    "description " + response.data.ClassroomId.toString(),
                  createdBy: state.IMCasalomaUserLogin.user._id,
                  shortInfo:
                    "short info " + response.data.ClassroomId.toString(),
                  startTime: "2022-05-03T03:33:04.106+00:00",
                  endTime: "2025-06-03T03:33:04.106+00:00",
                };
                console.log(newClass);
                let formDataClass = new FormData();
                formDataClass.append("name", newClass.name);
                formDataClass.append("shortInfo", newClass.shortInfo);
                formDataClass.append("createdBy", newClass.createdBy);
                formDataClass.append("description", newClass.description);
                formDataClass.append("startTime", newClass.startTime);
                formDataClass.append("endTime", newClass.endTime);
                const responseIMCreateClass = await imCasalomaAxios.post(
                  `/class`,
                  newClass
                );
                console.log(responseIMCreateClass);
                if (responseIMCreateClass.data.error == true) {
                } else {
                  commit(
                    `setIMCasalomaUserClass`,
                    responseIMCreateClass.data.payload
                  );
                  const responseIMFetchChat = await imCasalomaAxios.get(
                    `/chat/${responseIMCreateClass.data.payload.class._id}`,
                    {}
                  );
                  console.log(responseIMFetchChat);
                  commit(`setIMCasalomaFetchChats`, responseIMFetchChat);
                  commit(
                    "setCurrentlyViewingClass",
                    responseIMCreateClass.data.payload.class
                  );
                }
              } else {
                //join Class
                commit(`setIMCasalomaUserClass`, responseIMClass.data.payload);
                const responseIMFetchChat = await imCasalomaAxios.get(
                  `/chat/${responseIMClass.data.payload.class._id}`,
                  {}
                );
                console.log(responseIMFetchChat);
                commit(`setIMCasalomaFetchChats`, responseIMFetchChat);
                commit(
                  "setCurrentlyViewingClass",
                  responseIMClass.data.payload.class
                );
              }
            }
          }

          if (response.data.userType == 1) {
            commit("setTeacherState", true);
            router.push("/NewTeachingPlatform/hitutor-teacherv2");
          } else if (response.data.userType == 2) {
            commit("setTeacherState", false);
            router.push("/NewTeachingPlatform/hitutor-employeev2");
          } else if (response.data.userType == 3) {
            commit("setTeacherState", false);
            router.push("/NewTeachingPlatform/hitutor-observationv2");
          } else {
            commit("setTeacherState", false);
            router.push("/NewTeachingPlatform/hitutor-studentv2");
          }
        } catch (error) {
          console.log(error);
          sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
          commit(`setErrorLogs`, {
            name: "joinClassroom (Catch)",
            error: error,
            problem: "Problem when enter Join Classroom 2",
          });
          if (response.data.userType == 1) {
            commit("setTeacherState", true);
            router.push("/NewTeachingPlatform/hitutor-teacherv2");
          } else if (response.data.userType == 2) {
            commit("setTeacherState", false);
            router.push("/NewTeachingPlatform/hitutor-employeev2");
          } else if (response.data.userType == 3) {
            commit("setTeacherState", false);
            router.push("/NewTeachingPlatform/hitutor-observationv2");
          } else {
            commit("setTeacherState", false);
            router.push("/NewTeachingPlatform/hitutor-studentv2");
          }
        }
      } else {
        // console.log(response.data);
        alert("Failed to enter Classroom");
        commit(`setErrorLogs`, {
          name: "joinClassRoom 2 (catch)",
          error: response,
          problem: "Problem when join classroom 2",
        });

        if (response.data.userType == 1) {
          commit("setTeacherState", true);
          router.push("/NewTeachingPlatform/hitutor-teacherv2");
        } else if (response.data.userType == 2) {
          commit("setTeacherState", false);
          router.push("/NewTeachingPlatform/hitutor-employeev2");
        } else if (response.data.userType == 3) {
          commit("setTeacherState", false);
          router.push("/NewTeachingPlatform/hitutor-observationv2");
        } else {
          commit("setTeacherState", false);
          router.push("/NewTeachingPlatform/hitutor-studentv2");
        }
      }

      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(response) });
    } catch (error) {
      console.log(error);
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "joinClassRoom 2 (catch)",
        error: error,
        problem: "Problem when join classroom 2",
      });

      if (response.data.userType == 1) {
        commit("setTeacherState", true);
        router.push("/NewTeachingPlatform/hitutor-teacherv2");
      } else if (response.data.userType == 2) {
        commit("setTeacherState", false);
        router.push("/NewTeachingPlatform/hitutor-employeev2");
      } else if (response.data.userType == 3) {
        commit("setTeacherState", false);
        router.push("/NewTeachingPlatform/hitutor-observationv2");
      } else {
        commit("setTeacherState", false);
        router.push("/NewTeachingPlatform/hitutor-studentv2");
      }
    }
  },
  async joinNewClassHitutor({ state, commit, dispatch }, payload) {
    commit("setClearErrorLogs");
    const response = await hitutoraxios.post(
      `/api/NewTeachingPlatform/GetEnterClassroomInfo`,
      payload,
      {}
    );
    console.log("dataClass", response);
    try {
      if (response.data.IsSuccess) {
        // 获取agora的token
        const agoraTokenData = await agoraAxios.get(
          `/rtc/${response.data.ClassroomId}`
        );
        commit("setAgoraToken", agoraTokenData.data.rtcToken);
        commit("setAgoraChannel", response.data.ClassroomId);
        commit("setAgoraUid", response.data.UserId);

        sessionStorage.setItem("agoraUid", response.data.UserId);
        sessionStorage.setItem("agoraChannel", response.data.ClassroomId);
        sessionStorage.setItem("agoraToken", agoraTokenData.data.rtcToken);
        sessionStorage.setItem("userType", response.data.userType);
        sessionStorage.setItem("userName", response.data.UserName);
        sessionStorage.setItem("BeginTimeStamp", response.data.BeginTimeStamp);
        sessionStorage.setItem("EndTimeStamp", response.data.EndTimeStamp);

        if (response.data.userType == 1 && response.data.ClockInTimeStamp)
          sessionStorage.setItem(
            "ClockInTimeStamp",
            response.data.ClockInTimeStamp
          );

        if (response.data.userType == 2) {
          sessionStorage.setItem("employeeName", response.data.UserName);
        }

        //const isAnyClassMatesProps = Object.hasOwn(response.data, "classmateItems");
        const isAnyClassMatesProps = hasProperty(
          response.data,
          "classmateItems"
        );
        if (isAnyClassMatesProps == false || isAnyClassMatesProps === false) {
          commit("setOnlineUsers", []);
        } else {
          commit("setOnlineUsers", response.data.classmateItems);
        }

        // 2022-12-15 Peter 進教室整理訊息array
        if (response.data.liveChatContents.length > 0) {
          for (var i = 0; i < response.data.liveChatContents.length; i++) {
            var ContentArray = JSON.parse(
              response.data.liveChatContents[i].Content
            );

            response.data.liveChatContents[i].SendTime = moment(
              response.data.liveChatContents[i].SendTime
            ).format("YYYY-MM-DD HH:mm:ss");
            response.data.liveChatContents[i].FileName = ContentArray.FileName;
            response.data.liveChatContents[i].FileUrl = ContentArray.FileUrl;
            response.data.liveChatContents[i].Message = ContentArray.Message;
          }

          commit("setClassroomMessage", response.data.liveChatContents);
        } else {
          commit("setClassroomMessage", []);
        }

        commit(
          "setLiveChatChannel",
          response.data.LiveChatChannel.split("G-")[1]
        );

        // commit('setClassRoomId',2216502);
        commit("setClassRoomId", response.data.ClassroomId);
        commit("setHiTutorToken", response.data.Token);
        commit("setUserId", response.data.UserId);
        commit("setUserName", response.data.UserName);
        commit("setUserType", response.data.userType);
        if (response.data.userType == 1) {
          commit("setTeacherName", response.data.UserName);
        }
        commit("setClassTime", response.data.ClassTime);
        // commit('setBeginTimeStamp',1665459025);
        commit("setBeginTimeStamp", response.data.BeginTimeStamp);
        commit("setEndTimeStamp", response.data.EndTimeStamp);

        commit("setLessonRecordUrlStore", response.data.LessonRecordUrl);
        commit("setTBUrlStore", response.data.TBUrl);

        // 設置臨時的userId channel token
        sessionStorage.setItem("userId", response.data.UserId);
        sessionStorage.setItem("classroomId", response.data.ClassroomId);
        sessionStorage.setItem("agoraToken", agoraTokenData.data.rtcToken);

        // 先抓教材資料（不依賴 IP，獨立執行避免被下方 IP 請求失敗影響）
        // const response_media_object=await hitutoraxios.post(`/api/NewTeachingPlatform/GetClassroomMaterials`,{
        //   "ClassroomId": response.data.ClassroomId,
        //   "LastPage": 0,
        //   "RequestPages": 10,
        //   // "ClassroomId":2216502
        // },
        const response_media_object = await hitutoraxios.post(
          `/api/NewTeachingPlatform/GetClassroomMaterials`,
          {
            ClassroomId: response.data.ClassroomId,
            RequestPages: 10,
            // "ClassroomId":2216502
          },
          {
            headers: {
              Authorization: `Bearer ${response.data.Token}`,
            },
          }
        );

        console.log("Response Media Object");
        console.log(response_media_object);
        // Old handling materials data

        try {
          //const isAnyMessageProps = Object.hasOwn(response_media_object.data, "Message");
          const isAnyMessageProps = hasProperty(
            response_media_object.data,
            "Message"
          );
          if (isAnyMessageProps == false || isAnyMessageProps === false) {
            commit(
              "setMaterialMediaObject",
              response_media_object.data.MaterialMediaObject
            );
            commit(
              "setMaterialVedioObject",
              response_media_object.data.MaterialVedioObject
            );
            commit(
              "setMaterialObject",
              response_media_object.data.MaterialObject
            );
          } else {
            const responseMaterialObject = [];
            commit("setMaterialObject", responseMaterialObject);

            const responseVedioObject = [];
            commit("setMaterialVedioObject", responseVedioObject);

            const responseMaterialMediaObject = [];
            commit("setMaterialMediaObject", responseMaterialMediaObject);
          }
        } catch (error) {
          const responseMaterialObject = [];
          commit("setMaterialObject", responseMaterialObject);

          const responseVedioObject = [];
          commit("setMaterialVedioObject", responseVedioObject);

          const responseMaterialMediaObject = [];
          commit("setMaterialMediaObject", responseMaterialMediaObject);
          sendMainHitutorLog(
            { state, commit },
            { Log: JSON.stringify(error) }
          );
          commit(`setErrorLogs`, {
            name: "responseMaterialMediaObject (catch)",
            error: error,
            problem:
              "Problem when set responseMaterialMediaObject in Join Classroom 2",
          });
        }

        try {
          /* Storing user's device details in a variable*/
          let details = navigator.userAgent;

          /* Creating a regular expression 
                    containing some mobile devices keywords 
                    to search it in details string*/
          let regexp = /android|iphone|kindle|ipad/i;

          /* Using test() method to search regexp in details
                    it returns boolean value*/
          let isMobileDevice = regexp.test(details);
          let device;
          let OSName;
          let ip_address;

          if (isMobileDevice) {
            device = "Mobile";
          } else {
            device = "Desktop";
          }

          if (navigator.appVersion.indexOf("Win") != -1) OSName = "Windows OS";
          if (navigator.appVersion.indexOf("Mac") != -1) OSName = "MacOS";
          if (navigator.appVersion.indexOf("X11") != -1) OSName = "UNIX OS";
          if (navigator.appVersion.indexOf("Linux") != -1) OSName = "Linux OS";

          const url = "https://api.ipify.org/?format=json";

          ip_address = await fetch(url)
            .then((response) => response.json())
            .then((data) => data);

          var hituteIdentifier = response.data.UserId + "hitute-" + Date.now();
          commit("setHituteIdentifier", hituteIdentifier);

          let datapacket = {};
          // alert(JSON.stringify(datapacket));
          var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
          var version_number = raw ? parseInt(raw[2], 10) : false;

          if (isMobileBrowser()) {
            datapacket = {
              Identifier: hituteIdentifier,
              ClassroomId: response.data.ClassroomId,
              OS: OSName,
              Model: device,
              Browser: getMobileBrowserType(),
              BrowserVersion: window.navigator.appVersion,
              ClientIP: String(ip_address.ip),
              Headers: window.navigator.userAgent,
            };

            if (
              window.navigator.vendor === "Google Inc." ||
              getMobileBrowserType() === "Google Chrome Mobile (Android)" ||
              getMobileBrowserType() === "Google Chrome Mobile (iOS)"
            ) {
              if (version_number < 97) {
                commit(`setErrorLogs`, {
                  name: "browser version error",
                  error: "chrome version is not good",
                  problem:
                    "Brower Warning msg: 為了確保課程進行順暢，瀏覽器請使用 Chrome（版本：97......以上）。謝謝",
                });
                // alert("Brower Warning msg: 為了確保課程進行順暢，瀏覽器請使用 Chrome（版本：97......以上）。謝謝。")
              }
            } else {
              commit(`setErrorLogs`, {
                name: "not use chrome",
                error: "you are not using chrome",
                problem: "請使用Chrome瀏覽器以獲得最佳上課體驗",
              });
            }
          } else {
            datapacket = {
              Identifier: hituteIdentifier,
              ClassroomId: response.data.ClassroomId,
              OS: OSName,
              Model: device,
              Browser: getBrowserType(),
              BrowserVersion: window.navigator.appVersion,
              ClientIP: String(ip_address.ip),
              Headers: window.navigator.userAgent,
            };
            if (
              window.navigator.vendor === "Google Inc." ||
              getBrowserType() === "Google Chrome"
            ) {
              if (version_number < 97) {
                commit(`setErrorLogs`, {
                  name: "browser version error",
                  error: "chrome version is not good",
                  problem:
                    "Brower Warning msg: 為了確保課程進行順暢，瀏覽器請使用 Chrome（版本：97......以上）。謝謝",
                });
                // alert("Brower Warning msg: 為了確保課程進行順暢，瀏覽器請使用 Chrome（版本：97......以上）。謝謝。")
              }
            } else {
              commit(`setErrorLogs`, {
                name: "not use chrome",
                error: "you are not using chrome",
                problem: "請使用Chrome瀏覽器以獲得最佳上課體驗",
              });
            }
          }

          // alert(getMobileBrowserType());
          // alert(getBrowserType());
          const response_rtc_connected = await hitutoraxios.post(
            `/api/NewTeachingPlatform/ConnectedRtcServer`,
            datapacket,
            {
              headers: {
                Authorization: `Bearer ${response.data.Token}`,
              },
            }
          );

          // if (isMobileBrowser()) {

          // }
          // else {

          // }
          // var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
          // var version_number = raw ? parseInt(raw[2], 10) : false;
          // if(window.navigator.vendor == "Google Inc." || window.navigator.vendor === "Google Inc."){
          //     if(version_number<97){
          //         commit(`setErrorLogs`,{'name':'browser version error','error':'chrome version is not good','problem':'Brower Warning msg: 為了確保課程進行順暢，瀏覽器請使用 Chrome（版本：97......以上）。謝謝'});
          //         // alert("Brower Warning msg: 為了確保課程進行順暢，瀏覽器請使用 Chrome（版本：97......以上）。謝謝。")
          //     }
          // }else{
          //     commit(`setErrorLogs`,{'name':'not use chrome','error':'you are not using chrome','problem':'請使用Chrome瀏覽器以獲得最佳上課體驗'});

          // }

          const currentUserName = response.data.UserName;
          const currentUserEmail = currentUserName + "@hitutor.com";

          // const responseCheckCasalomaUser = await imCasalomaAxios.get(
          //   `/user/` + currentUserEmail
          // );
          // console.log(responseCheckCasalomaUser);
          // if (responseCheckCasalomaUser.data.error == true) {
          //   commit(`setIMCasalomaUserAvailability`, false);
          //   const userDataForRegister = {
          //     name: currentUserName,
          //     email: currentUserEmail,
          //     password: "hitutor",
          //     contact: "000000",
          //     image: "null",
          //     userType: "TEACHER",
          //   };
          //   let formData = new FormData();
          //   formData.append("name", userDataForRegister.name);
          //   formData.append("email", userDataForRegister.email);
          //   formData.append("password", userDataForRegister.password);
          //   formData.append("contact", userDataForRegister.contact);
          //   formData.append("image", userDataForRegister.image);
          //   formData.append("userType", userDataForRegister.userType);

          //   commit(`setErrorLogs`, {
          //     name: "responseCheckCasalomaUser",
          //     error: error,
          //     problem:
          //       "Problem when set responseCheckCasalomaUser in Join Classroom 2",
          //   });

          //   const responseIMRegister = await imCasalomaAxios.post(
          //     `/user/`,
          //     formData
          //   );
          //   if (responseIMRegister.data.error == true) {
          //     commit(
          //       `setIMCasalomaUserRegister`,
          //       responseIMRegister.data.payload
          //     );
          //     commit(`setErrorLogs`, {
          //       name: "responseIMRegister",
          //       error: error,
          //       problem:
          //         "Problem when set responseIMRegister in Join Classroom 2",
          //     });
          //   } else {
          //     commit(
          //       `setIMCasalomaUserRegister`,
          //       responseIMRegister.data.payload
          //     );

          //     commit(`setIMCasalomaUserAvailability`, true);
          //     const userDataForLogin = {
          //       email: currentUserEmail,
          //       password: "hitutor",
          //     };
          //     const responseIMLogin = await imCasalomaAxios.post(
          //       `/user/login`,
          //       userDataForLogin
          //     );
          //     console.log("Response IM Login");
          //     console.log(responseIMLogin);
          //     console.log(responseIMLogin.data);
          //     if (responseIMLogin.data.error == true) {
          //       commit(`setIMCasalomaUserLogin`, responseIMLogin.data.payload);
          //       commit(`setErrorLogs`, {
          //         name: "responseIMLogin",
          //         error: error,
          //         problem:
          //           "Problem when set responseIMLogin in Join Classroom 2",
          //       });
          //     } else {
          //       commit(`setIMCasalomaUserLogin`, responseIMLogin.data.payload);
          //       const { user, jwtToken } = responseIMLogin.data.payload;
          //       commit("setUser", { user, jwtToken });

          //       //if  class available
          //       const responseIMClass = await imCasalomaAxios.get(
          //         `/class/checkclass/` + response.data.ClassroomId
          //       );
          //       console.log(responseIMClass);
          //       if (responseIMClass.data.payload.class == null) {
          //         //create new class
          //         const newClass = {
          //           name: response.data.ClassroomId.toString(),
          //           description:
          //             "description " + response.data.ClassroomId.toString(),
          //           createdBy: state.IMCasalomaUserLogin.user._id,
          //           shortInfo:
          //             "short info " + response.data.ClassroomId.toString(),
          //           startTime: "2022-05-03T03:33:04.106+00:00",
          //           endTime: "2025-06-03T03:33:04.106+00:00",
          //         };

          //         console.log(newClass);
          //         let formDataClass = new FormData();
          //         formDataClass.append("name", newClass.name);
          //         formDataClass.append("shortInfo", newClass.shortInfo);
          //         formDataClass.append("createdBy", newClass.createdBy);
          //         formDataClass.append("description", newClass.description);
          //         formDataClass.append("startTime", newClass.startTime);
          //         formDataClass.append("endTime", newClass.endTime);
          //         const responseIMCreateClass = await imCasalomaAxios.post(
          //           `/class`,
          //           newClass
          //         );
          //         console.log(responseIMCreateClass);
          //         if (responseIMCreateClass.data.error == true) {
          //           commit(`setErrorLogs`, {
          //             name: "responseIMCreateClass",
          //             error: responseIMCreateClass,
          //             problem:
          //               "Problem when set responseIMCreateClass in Join Classroom 2",
          //           });
          //         } else {
          //           commit(
          //             `setIMCasalomaUserClass`,
          //             responseIMCreateClass.data.payload
          //           );
          //           const responseIMFetchChat = await imCasalomaAxios.get(
          //             `/chat/${responseIMCreateClass.data.payload.class._id}`,
          //             {}
          //           );
          //           console.log(responseIMFetchChat);
          //           commit(`setIMCasalomaFetchChats`, responseIMFetchChat);
          //           commit(
          //             "setCurrentlyViewingClass",
          //             responseIMCreateClass.data.payload.class
          //           );
          //         }
          //       } else {
          //         //join class
          //         commit(
          //           `setIMCasalomaUserClass`,
          //           responseIMClass.data.payload
          //         );
          //         const responseIMFetchChat = await imCasalomaAxios.get(
          //           `/chat/${responseIMClass.data.payload.class._id}`,
          //           {}
          //         );
          //         console.log(responseIMFetchChat);
          //         commit(`setIMCasalomaFetchChats`, responseIMFetchChat);
          //         commit(
          //           "setCurrentlyViewingClass",
          //           responseIMClass.data.payload.class
          //         );
          //       }
          //     }
          //   }
          // } else {
          //   commit(`setIMCasalomaUserAvailability`, true);
          //   const userDataForLogin = {
          //     email: currentUserEmail,
          //     password: "hitutor",
          //   };
          //   const responseIMLogin = await imCasalomaAxios.post(
          //     `/user/login`,
          //     userDataForLogin
          //   );
          //   console.log("Response IM Login");
          //   console.log(responseIMLogin);
          //   console.log(responseIMLogin.data);
          //   if (responseIMLogin.data.error == true) {
          //     commit(`setIMCasalomaUserLogin`, responseIMLogin.data.payload);
          //     commit(`setErrorLogs`, {
          //       name: "responseIMLogin",
          //       error: responseIMLogin,
          //       problem: "Problem when set responseIMLogin in Join Classroom 2",
          //     });
          //   } else {
          //     console.log("Success Login Response");
          //     commit(`setIMCasalomaUserLogin`, responseIMLogin.data.payload);
          //     const { user, jwtToken } = responseIMLogin.data.payload;
          //     commit("setUser", { user, jwtToken });
          //     //if class available
          //     const responseIMClass = await imCasalomaAxios.get(
          //       `/class/checkclass/` + response.data.ClassroomId
          //     );
          //     console.log(responseIMClass);
          //     if (responseIMClass.data.payload.class == null) {
          //       //create new class
          //       const newClass = {
          //         name: response.data.ClassroomId.toString(),
          //         description:
          //           "description " + response.data.ClassroomId.toString(),
          //         createdBy: state.IMCasalomaUserLogin.user._id,
          //         shortInfo:
          //           "short info " + response.data.ClassroomId.toString(),
          //         startTime: "2022-05-03T03:33:04.106+00:00",
          //         endTime: "2025-06-03T03:33:04.106+00:00",
          //       };
          //       console.log(newClass);
          //       let formDataClass = new FormData();
          //       formDataClass.append("name", newClass.name);
          //       formDataClass.append("shortInfo", newClass.shortInfo);
          //       formDataClass.append("createdBy", newClass.createdBy);
          //       formDataClass.append("description", newClass.description);
          //       formDataClass.append("startTime", newClass.startTime);
          //       formDataClass.append("endTime", newClass.endTime);
          //       const responseIMCreateClass = await imCasalomaAxios.post(
          //         `/class`,
          //         newClass
          //       );
          //       console.log(responseIMCreateClass);
          //       if (responseIMCreateClass.data.error == true) {
          //       } else {
          //         commit(
          //           `setIMCasalomaUserClass`,
          //           responseIMCreateClass.data.payload
          //         );
          //         const responseIMFetchChat = await imCasalomaAxios.get(
          //           `/chat/${responseIMCreateClass.data.payload.class._id}`,
          //           {}
          //         );
          //         console.log(responseIMFetchChat);
          //         commit(`setIMCasalomaFetchChats`, responseIMFetchChat);
          //         commit(
          //           "setCurrentlyViewingClass",
          //           responseIMCreateClass.data.payload.class
          //         );
          //       }
          //     } else {
          //       //join Class
          //       commit(`setIMCasalomaUserClass`, responseIMClass.data.payload);
          //       const responseIMFetchChat = await imCasalomaAxios.get(
          //         `/chat/${responseIMClass.data.payload.class._id}`,
          //         {}
          //       );
          //       console.log(responseIMFetchChat);
          //       commit(`setIMCasalomaFetchChats`, responseIMFetchChat);
          //       commit(
          //         "setCurrentlyViewingClass",
          //         responseIMClass.data.payload.class
          //       );
          //     }
          //   }
          // }
          payload;
          // if (response.data.userType == 1) {
          //     commit('setTeacherState', true);
          //     router.push('/NewTeachingPlatform/hitutor-teacher');
          // } else if (response.data.userType == 2) {
          //     commit('setTeacherState', false);
          //     router.push('/NewTeachingPlatform/hitutor-employee');
          // } else if (response.data.userType == 3) {
          //     commit('setTeacherState', false);
          //     router.push('/NewTeachingPlatform/hitutor-observation');
          // } else {
          //     commit('setTeacherState', false);
          //     // router.push('/NewTeachingPlatform/hitutor-student');
          //     router.push('/NewTeachingPlatform/hitutor-student-wb');
          // }
        } catch (error) {
          console.log(error);
          sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
          commit(`setErrorLogs`, {
            name: "joinClassroom (Catch)",
            error: error,
            problem: "Problem when enter Join Classroom 2",
          });
          // if (response.data.userType == 1) {
          //     commit('setTeacherState', true);
          //     router.push('/NewTeachingPlatform/hitutor-teacher');
          // } else if (response.data.userType == 2) {
          //     commit('setTeacherState', false);
          //     router.push('/NewTeachingPlatform/hitutor-employee');
          // } else if (response.data.userType == 3) {
          //     commit('setTeacherState', false);
          //     router.push('/NewTeachingPlatform/hitutor-observation');
          // } else {
          //     commit('setTeacherState', false);
          //     // router.push('/NewTeachingPlatform/hitutor-student');
          //     router.push('/NewTeachingPlatform/hitutor-student-wb');
          // }
        }
      } else {
        // console.log(response.data);
        alert("Failed to enter Classroom");
        commit(`setErrorLogs`, {
          name: "joinClassRoom 2 (catch)",
          error: response,
          problem: "Problem when join classroom 2",
        });

        if (response.data.userType == 1) {
          commit("setTeacherState", true);
          router.push("/NewTeachingPlatform/hitutor-teacher");
        } else if (response.data.userType == 2) {
          commit("setTeacherState", false);
          router.push("/NewTeachingPlatform/hitutor-employee");
        } else if (response.data.userType == 3) {
          commit("setTeacherState", false);
          router.push("/NewTeachingPlatform/hitutor-observation");
        } else {
          commit("setTeacherState", false);
          // router.push('/NewTeachingPlatform/hitutor-student');
          router.push("/NewTeachingPlatform/hitutor-student-wb");
        }
      }

      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(response) });
    } catch (error) {
      console.log(error);
      sendMainHitutorLog({ state, commit }, { Log: JSON.stringify(error) });
      commit(`setErrorLogs`, {
        name: "joinClassRoom 2 (catch)",
        error: error,
        problem: "Problem when join classroom 2",
      });

      if (response.data.userType == 1) {
        commit("setTeacherState", true);
        router.push("/NewTeachingPlatform/hitutor-teacher");
      } else if (response.data.userType == 2) {
        commit("setTeacherState", false);
        router.push("/NewTeachingPlatform/hitutor-employee");
      } else if (response.data.userType == 3) {
        commit("setTeacherState", false);
        router.push("/NewTeachingPlatform/hitutor-observation");
      } else {
        commit("setTeacherState", false);
        // router.push('/NewTeachingPlatform/hitutor-student');
        router.push("/NewTeachingPlatform/hitutor-student-wb");
      }
    }
  },

  // 開啟雲端錄製
  async aograRecordStart() {
    // const existingSid = sessionStorage.getItem("sid");
    // const existingRes = sessionStorage.getItem("resourceId");

    // // If there is a leftover recording session, stop it first
    // if (existingSid && existingRes) {
    //   try {
    //     console.warn("Found leftover recording session, stopping first...");
    //     await aograRecordAxios.post("/stop", {
    //       mode: "mix",
    //       channel: sessionStorage.getItem("classroomId"),
    //       uid: sessionStorage.getItem("userId"),
    //       resourceId: existingRes,
    //       sid: existingSid,
    //     });
    //   } catch (err) {
    //     console.error("Error stopping leftover recording:", err);
    //   } finally {
    //     sessionStorage.removeItem("sid");
    //     sessionStorage.removeItem("resourceId");
    //   }
    // }

    var generatedUid = generateRecordingUid(sessionStorage.getItem("userId"));
    await aograRecordAxios
      .post("/acquire", {
        channel: sessionStorage.getItem("classroomId"),
        uid: generatedUid, // Use a fixed UID for recording
        expiredHour: 24,
        scene: 0,
      })
      .then((res) => {
        sessionStorage.setItem("resourceId", res.data.resourceId);
        aograRecordAxios
          .post("/start", {
            mode: "mix",
            channel: sessionStorage.getItem("classroomId"),
            uid: generatedUid,
            resourceId: sessionStorage.getItem("resourceId"),
            token: sessionStorage.getItem("agoraToken"),
          })
          .then((response) => {
            sessionStorage.setItem(
              "agoraStartData",
              JSON.stringify(response.data)
            );
            sessionStorage.setItem("sid", response.data.sid);
            sessionStorage.setItem("recordingUid", generatedUid);
          });
      });
  },
  // 關閉雲端錄製
  async aograRecordStop() {
    await aograRecordAxios
      .post("/stop", {
        mode: "mix",
        channel: sessionStorage.getItem("classroomId"),
        uid: sessionStorage.getItem("recordingUid"),
        resourceId: sessionStorage.getItem("resourceId"),
        sid: sessionStorage.getItem("sid"),
      })
      .then((res) => {
        sessionStorage.setItem("agoraStopData", JSON.stringify(res.data));
        sessionStorage.removeItem("sid");
        sessionStorage.removeItem("resourceId");
      });
  },

  async aograRecordQuery({ state, commit }) {
    await aograRecordAxios
      .post("/query", {
        resourceId: sessionStorage.getItem("resourceId"),
        sid: sessionStorage.getItem("sid"),
        mode: "mix",
      })
      .then((res) => {
        console.log("Recording Query", res);
        commit("setLessonRecordQuery", res.data);
      });
  },
};

export default classActions;
